import React from "react";
import LegalLayout from "../../components/LegalLayout";
import { hotel } from "../../mock";

const Terms = () => (
  <LegalLayout title="Kullanım Koşulları" updated="Haziran 2026">
    <p>
      Bu web sitesini kullanarak aşağıdaki kullanım koşullarını kabul etmiş
      sayılırsınız. Lütfen siteyi kullanmadan önce bu koşulları dikkatlice okuyunuz.
    </p>

    <h2>1. Genel Hükümler</h2>
    <p>
      Bu web sitesi Safranbolu Çelebi Otel tarafından bilgilendirme ve iletişim
      amacıyla sunulmaktadır. Sitedeki içerikler önceden haber verilmeksizin
      değiştirilebilir.
    </p>

    <h2>2. Fikri Mülkiyet Hakları</h2>
    <p>
      Sitede yer alan metin, görsel, logo ve tasarımlar dâhil tüm içerikler telif
      hakkı ile korunmaktadır. İzinsiz kopyalanamaz, çoğaltılamaz veya ticari amaçla
      kullanılamaz. Çevre lokasyonlara ait bazı görseller ilgili lisansları (CC
      BY-SA 4.0) kapsamında kullanılmaktadır.
    </p>

    <h2>3. Rezervasyon Talepleri</h2>
    <p>
      Web sitesi veya WhatsApp üzerinden ilettiğiniz rezervasyon talepleri bir{" "}
      <strong>talep</strong> niteliğindedir; kesin rezervasyon, müsaitlik ve fiyat
      teyidi sonrasında otelimiz tarafından onaylandığında geçerlilik kazanır.
    </p>

    <h2>4. Sorumluluğun Sınırlandırılması</h2>
    <p>
      Sitedeki bilgilerin güncel ve doğru olması için azami özen gösterilmekle
      birlikte, olası hata veya eksikliklerden doğabilecek zararlardan otelimiz
      sorumlu tutulamaz. Uzaklık ve süre bilgileri yaklaşık değerlerdir.
    </p>

    <h2>5. Üçüncü Taraf Bağlantıları</h2>
    <p>
      Sitemiz, üçüncü taraf hizmetlere (ör. WhatsApp, harita hizmetleri) bağlantılar
      içerebilir. Bu hizmetlerin içerik ve gizlilik uygulamalarından otelimiz sorumlu
      değildir.
    </p>

    <h2>6. Değişiklikler</h2>
    <p>
      Bu kullanım koşulları zaman zaman güncellenebilir. Güncel sürüm her zaman bu
      sayfada yayımlanır.
    </p>

    <h2>7. Uygulanacak Hukuk</h2>
    <p>
      Bu koşulların yorumlanmasında ve uygulanmasında Türkiye Cumhuriyeti hukuku
      geçerlidir. Doğabilecek uyuşmazlıklarda Karabük mahkemeleri ve icra daireleri
      yetkilidir.
    </p>

    <h2>8. İletişim</h2>
    <p>
      Sorularınız için: <strong>{hotel.email}</strong> · {hotel.phones[0]}
    </p>
  </LegalLayout>
);

export default Terms;
